import React, { useEffect, useState } from "react";
import "./login-verde.css";
import "../../styles/bg-responsive.css";
import "../../styles/auth-logo.css";

import sbfLogo from "../../assets/SBF-Logo-1.png";
// import bg from "../../assets/bg/3840x2160-desktop.png";

import useAuth from "../../hooks/useAuthContext";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import carregando from "../../assets/Spinner-1s-200px.gif";
import { isAdminTipo, redirectByTipo, isAcessoBloqueado } from "../../utils/userTipo";

const LoginVerde = () => {
  const { login, validarUser, verificaStorage, usuario } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const notifyError = (mensagem) => toast.error(mensagem, { theme: "colored" });
  const notifyInfo = (mensagem) => toast.info(mensagem, { theme: "colored" });
  const [showLoading, setShowLoading] = useState(false);

  useEffect(() => {
    handleUser();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [usuario]);

  const handleUser = async () => {
    let user = await validarUser();
    if (user?.acessoBloqueado) {
      navigate("/acesso-em-breve");
      return;
    }
    if (!user) {
      user = await verificaStorage();
    }

    if (user?.acessoBloqueado) {
      navigate("/acesso-em-breve");
      return;
    }

    if (user) {
      if (isAdminTipo(user.tipo)) {
        navigate("/private/adm");
        return;
      }
      redirectByTipo(user.tipo, navigate);
    }
  };

  const handleLogin = async () => {
    setShowLoading(true);
    let response = await login(email, password);
    if (response) {
      if (response?.status === 200) {
        redirectByTipo(response.data.dadosUser.tipo, navigate);
        return;
      }
      if (isAcessoBloqueado(response)) {
        navigate("/acesso-em-breve");
        setShowLoading(false);
        return;
      }
      if (response?.status === 401) {
        notifyInfo(response.data.mensagem);
      } else if (response?.data?.mensagem) {
        notifyError(
          response.data.mensagem + (response.data.erro ? " - " + response.data.erro : "")
        );
      }
      setShowLoading(false);
    }
  };

  return (
    <div id="container-login-verde">
      <div id="container-central-verde">
        <img src={sbfLogo} alt="SBF" id="img-logo-verde" />
        <div id="container-inputs-verde">
          <input
            type="text"
            placeholder="Email"
            onChange={(e) => setEmail(e.target.value)}
          />
          <input
            type="password"
            placeholder="Senha"
            onChange={(e) => setPassword(e.target.value)}
          />
          <button
            className={`btn px-5 text-white mt-2 ${showLoading ? "bt-loading" : ""
              }`}
            id="botao-acessar-verde"
            onClick={() => {
              handleLogin();
            }}
          >
            {showLoading ? (
              <img src={carregando} width="30" alt="loading" />
            ) : (
              "Acessar"
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default LoginVerde;
